/**
 * Bulk-check registry. Maps a favorite service to how (and whether)
 * Lites can run a 10-name availability check against it.
 *
 *   'smn-deeplink' — open SecureMyName with ?bulk=1&names=... in a new
 *                    tab; SMN renders results in its own UI. No backend
 *                    call from Lites. Works for any signed-in user.
 *
 *   'ud-proxy'     — POST stems to /api/ud/bulk-search; the backend
 *                    decrypts the user's stored UD MCP key and calls
 *                    UD's MCP server on their behalf. Requires (a)
 *                    paid tier and (b) a stored UD MCP key.
 *
 *   null           — no bulk-check available for this favorite.
 *
 * Detection prefers canonical id matching with a URL-template fallback
 * for users who renamed their favorite.
 */
import type { FavoriteSite } from '../types';

export type BulkCheckMode = 'smn-deeplink' | 'ud-proxy' | null;

export function supportsBulkCheck(
  fav: FavoriteSite | undefined | null,
): BulkCheckMode {
  if (!fav) return null;
  const id = (fav.id || '').toLowerCase();
  const template = (fav.template || '').toLowerCase();

  if (id === 'securemyname' || template.includes('securemyname.com')) {
    return 'smn-deeplink';
  }
  if (id === 'unstoppable' || template.includes('unstoppabledomains.com')) {
    return 'ud-proxy';
  }
  return null;
}
